export default {
  config: {
    appType: "NG",
    leftNavCollapsed: false,
    isQA: false,
    useRoles: false,
    ready: false,
    showAgencyName: false,
    data: {},
    brand: {}
  },
  roles: [],
  left: [],
  admin: [],
  help: [],
  user: [],
  whatsNew: []
};
